import { Typography } from "@mui/material";
import React from "react";

export default function TextBankInfo({ children, ...props }) {
  return (
    <Typography
      sx={{
        display: "-webkit-box",
        overflow: "hidden",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 1,
      }}
      variant="caption"
      color="rgba(100, 116, 139, 1)"
      fontWeight={400}
    >
      {children}
    </Typography>
  );
}
